import { ViewpointBuilderContext } from 'viewpointBuilder/types';
import { getSidebarTitleFromContext } from 'viewpointBuilder/viewpointBuilderNavigation/viewpointBuilderNavigationOperations';
import { t, type I18nLocale } from '@ardoq/i18n';

export type ContextConfig = {
  isNavigationPanelHidden: boolean;
  isComponentTypeSelectionDisabled: boolean;
  graphViewTitle: string;
  modalTitle: string;
};

export const getContextConfig = (
  context: ViewpointBuilderContext,
  i18nLocale: I18nLocale
): ContextConfig => {
  return {
    isNavigationPanelHidden: context === 'openViewpoint',
    isComponentTypeSelectionDisabled: context === 'openViewpoint',
    graphViewTitle: getGraphViewTitle(context, i18nLocale),
    modalTitle: getModalTitle(context, i18nLocale),
  };
};

const getModalTitle = (
  context: ViewpointBuilderContext,
  i18nLocale: I18nLocale
): string => {
  if (context === 'openViewpoint') {
    return t(
      i18nLocale,
      'viewpointBuilder:selectContext.modal.title',
      'Select context component(s)'
    );
  }
  return getSidebarTitleFromContext(context, i18nLocale);
};

const getGraphViewTitle = (
  context: ViewpointBuilderContext,
  i18nLocale: I18nLocale
): string => {
  switch (context) {
    case 'createViewpoint':
    case 'editViewpoint':
      return t(
        i18nLocale,
        'viewpointBuilder:graphView.viewpointMetamodel',
        'Viewpoint metamodel'
      );
    default:
      return t(
        i18nLocale,
        'viewpointBuilder:graphView.datasetMetamodel',
        'Dataset metamodel'
      );
  }
};
